import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AdminProtectedRoute } from './components/AdminProtectedRoute';
import { SuperAdminProtectedRoute } from './components/SuperAdminProtectedRoute';

import { GetStartedPage } from './pages/GetStartedPage';
import { LoginPage } from './pages/LoginPage';
import { ConversationsPage } from './pages/ConversationsPage';
import { ChatPage } from './pages/ChatPage';
import { DocumentStatsPage } from './pages/DocumentStatsPage';
import { DashboardPage } from './pages/DashboardPage';
import { HtmlTestResultsPage } from './pages/TestResultsPage';
import { Toaster } from './components/ui/sonner';
import { FeedbackGlobalPage } from './pages/FeedbackGlobalPage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/get-started" element={<GetStartedPage />} />
          <Route path="/login" element={<LoginPage />} />

          {/* Main App - Profile Required */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <ChatPage />
              </ProtectedRoute>
            }
          />

          {/* Admin Routes - Cognito Authentication Required */}
          <Route
            path="/conversations"
            element={
              <AdminProtectedRoute>
                <ConversationsPage />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/document-usage"
            element={
              <AdminProtectedRoute>
                <DocumentStatsPage />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <AdminProtectedRoute>
                <DashboardPage />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/feedback-global"
            element={
              <AdminProtectedRoute>
                <FeedbackGlobalPage />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/test-results"
            element={
              <SuperAdminProtectedRoute>
                <HtmlTestResultsPage />
              </SuperAdminProtectedRoute>
            }
          />
        </Routes>
      </Router>
      <Toaster />
    </AuthProvider>
  );
}

export default App;
